// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Offset type — classifies offsets by category with display color
 * and custom attributes.
 */
export class OffsetType implements flatbuffers.IUnpackableObject<OffsetTypeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OffsetType {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOffsetType(bb: flatbuffers.ByteBuffer, obj?: OffsetType): OffsetType {
    return (obj || new OffsetType()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsOffsetType(bb: flatbuffers.ByteBuffer, obj?: OffsetType): OffsetType {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OffsetType()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  color(): string | null;
  color(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  color(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * JSON-encoded custom attributes for this offset type.
   */
  attributesJson(): string | null;
  attributesJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  attributesJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Data-block ids to ATTACH to this offset type (many2many). Mirrors
   * models.OffsetTypeRequest.DataBlocks (`json:"data_blocks"`). Named
   * data_block_ids, NOT data_blocks, because models.OffsetType (the GET
   * response this table also represents) preloads a
   * `DataBlocks []*DataBlock` association under that exact same json tag
   * (`offset-type.model.go:19`) — a field named data_blocks here would
   * collide with that full-object shape (same rule as DataBlock's
   * offset_type_ids below).
   *
   * Appended at the end of the table to preserve `FlatBuffer` wire
   * compatibility — never insert fields in the middle.
   */
  dataBlockIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  dataBlockIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Data-block ids to DETACH. Mirrors OffsetTypeRequest.DataBlocks2Delete
   * (`json:"data_blocks_2delete"` — note the underscore before "2delete",
   * reproduced from the Go tag exactly). Suffixed _ids for the same
   * reason as data_block_ids above.
   */
  dataBlockIds2delete(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  dataBlockIds2deleteLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Offset ids to ATTACH (repoints offsets.offset_type_id). Mirrors
   * OffsetTypeRequest.Offsets (`json:"offsets"`). Named offset_ids, NOT
   * offsets, because models.OffsetType preloads an `Offsets []*Offset`
   * association under that exact same json tag (offset-type.model.go:20)
   * — same collision this table's data_block_ids field name already
   * avoids.
   */
  offsetIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  offsetIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Accepted only so a non-empty value can be rejected with a 400
   * (controllers.rejectOffsetDetachRequest) — offsets.offset_type_id is
   * NOT NULL, so this is never a real detach. Mirrors
   * OffsetTypeRequest.Offsets2Delete (`json:"offsets2delete"`). Suffixed
   * _ids for the same reason as offset_ids above.
   */
  offsetIds2delete(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  offsetIds2deleteLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startOffsetType(builder: flatbuffers.Builder) {
    builder.startObject(11);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, colorOffset, 0);
  }

  static addAttributesJson(builder: flatbuffers.Builder, attributesJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, attributesJsonOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, deletedAtOffset, 0);
  }

  static addDataBlockIds(builder: flatbuffers.Builder, dataBlockIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, dataBlockIdsOffset, 0);
  }

  static createDataBlockIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDataBlockIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDataBlockIds2delete(
    builder: flatbuffers.Builder,
    dataBlockIds2deleteOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(8, dataBlockIds2deleteOffset, 0);
  }

  static createDataBlockIds2deleteVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDataBlockIds2deleteVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOffsetIds(builder: flatbuffers.Builder, offsetIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, offsetIdsOffset, 0);
  }

  static createOffsetIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOffsetIds2delete(
    builder: flatbuffers.Builder,
    offsetIds2deleteOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, offsetIds2deleteOffset, 0);
  }

  static createOffsetIds2deleteVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetIds2deleteVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endOffsetType(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createOffsetType(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    colorOffset: flatbuffers.Offset,
    attributesJsonOffset: flatbuffers.Offset,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
    dataBlockIdsOffset: flatbuffers.Offset,
    dataBlockIds2deleteOffset: flatbuffers.Offset,
    offsetIdsOffset: flatbuffers.Offset,
    offsetIds2deleteOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    OffsetType.startOffsetType(builder);
    OffsetType.addId(builder, idOffset);
    OffsetType.addName(builder, nameOffset);
    OffsetType.addColor(builder, colorOffset);
    OffsetType.addAttributesJson(builder, attributesJsonOffset);
    OffsetType.addCreatedAt(builder, createdAtOffset);
    OffsetType.addUpdatedAt(builder, updatedAtOffset);
    OffsetType.addDeletedAt(builder, deletedAtOffset);
    OffsetType.addDataBlockIds(builder, dataBlockIdsOffset);
    OffsetType.addDataBlockIds2delete(builder, dataBlockIds2deleteOffset);
    OffsetType.addOffsetIds(builder, offsetIdsOffset);
    OffsetType.addOffsetIds2delete(builder, offsetIds2deleteOffset);
    return OffsetType.endOffsetType(builder);
  }

  unpack(): OffsetTypeT {
    return new OffsetTypeT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.color(),
      this.attributesJson(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<Uuid, UuidT>(this.dataBlockIds.bind(this), this.dataBlockIdsLength()),
      this.bb!.createObjList<Uuid, UuidT>(
        this.dataBlockIds2delete.bind(this),
        this.dataBlockIds2deleteLength(),
      ),
      this.bb!.createObjList<Uuid, UuidT>(this.offsetIds.bind(this), this.offsetIdsLength()),
      this.bb!.createObjList<Uuid, UuidT>(
        this.offsetIds2delete.bind(this),
        this.offsetIds2deleteLength(),
      ),
    );
  }

  unpackTo(_o: OffsetTypeT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.color = this.color();
    _o.attributesJson = this.attributesJson();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.dataBlockIds = this.bb!.createObjList<Uuid, UuidT>(
      this.dataBlockIds.bind(this),
      this.dataBlockIdsLength(),
    );
    _o.dataBlockIds2delete = this.bb!.createObjList<Uuid, UuidT>(
      this.dataBlockIds2delete.bind(this),
      this.dataBlockIds2deleteLength(),
    );
    _o.offsetIds = this.bb!.createObjList<Uuid, UuidT>(
      this.offsetIds.bind(this),
      this.offsetIdsLength(),
    );
    _o.offsetIds2delete = this.bb!.createObjList<Uuid, UuidT>(
      this.offsetIds2delete.bind(this),
      this.offsetIds2deleteLength(),
    );
  }

  unpackFields(...fields: string[]): OffsetTypeT {
    const t = new OffsetTypeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("color")) {
      t.color = this.color();
    }
    if (fieldSet.has("attributes_json")) {
      t.attributesJson = this.attributesJson();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("data_block_ids")) {
      t.dataBlockIds = this.bb!.createObjList<Uuid, UuidT>(
        this.dataBlockIds.bind(this),
        this.dataBlockIdsLength(),
      );
    }
    if (fieldSet.has("data_block_ids_2delete")) {
      t.dataBlockIds2delete = this.bb!.createObjList<Uuid, UuidT>(
        this.dataBlockIds2delete.bind(this),
        this.dataBlockIds2deleteLength(),
      );
    }
    if (fieldSet.has("offset_ids")) {
      t.offsetIds = this.bb!.createObjList<Uuid, UuidT>(
        this.offsetIds.bind(this),
        this.offsetIdsLength(),
      );
    }
    if (fieldSet.has("offset_ids_2delete")) {
      t.offsetIds2delete = this.bb!.createObjList<Uuid, UuidT>(
        this.offsetIds2delete.bind(this),
        this.offsetIds2deleteLength(),
      );
    }
    return t;
  }
}

export class OffsetTypeT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public color: string | Uint8Array | null = null,
    public attributesJson: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public dataBlockIds: UuidT[] = [],
    public dataBlockIds2delete: UuidT[] = [],
    public offsetIds: UuidT[] = [],
    public offsetIds2delete: UuidT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const color = this.color !== null ? builder.createString(this.color!) : 0;
    const attributesJson =
      this.attributesJson !== null ? builder.createString(this.attributesJson!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const dataBlockIds = OffsetType.createDataBlockIdsVector(
      builder,
      builder.createObjectOffsetList(this.dataBlockIds),
    );
    const dataBlockIds2delete = OffsetType.createDataBlockIds2deleteVector(
      builder,
      builder.createObjectOffsetList(this.dataBlockIds2delete),
    );
    const offsetIds = OffsetType.createOffsetIdsVector(
      builder,
      builder.createObjectOffsetList(this.offsetIds),
    );
    const offsetIds2delete = OffsetType.createOffsetIds2deleteVector(
      builder,
      builder.createObjectOffsetList(this.offsetIds2delete),
    );

    return OffsetType.createOffsetType(
      builder,
      id,
      name,
      color,
      attributesJson,
      createdAt,
      updatedAt,
      deletedAt,
      dataBlockIds,
      dataBlockIds2delete,
      offsetIds,
      offsetIds2delete,
    );
  }

  clone(): OffsetTypeT {
    const obj = new OffsetTypeT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.color = this.color;
    obj.attributesJson = this.attributesJson;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.dataBlockIds = this.dataBlockIds.map((e) => e.clone());
    obj.dataBlockIds2delete = this.dataBlockIds2delete.map((e) => e.clone());
    obj.offsetIds = this.offsetIds.map((e) => e.clone());
    obj.offsetIds2delete = this.offsetIds2delete.map((e) => e.clone());
    return obj;
  }

  equals(other: OffsetTypeT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.color !== other.color) return false;
    if (this.attributesJson !== other.attributesJson) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.dataBlockIds.length !== other.dataBlockIds.length) return false;
    for (let i = 0; i < this.dataBlockIds.length; i++) {
      const a = this.dataBlockIds[i];
      const b = other.dataBlockIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.dataBlockIds2delete.length !== other.dataBlockIds2delete.length) return false;
    for (let i = 0; i < this.dataBlockIds2delete.length; i++) {
      const a = this.dataBlockIds2delete[i];
      const b = other.dataBlockIds2delete[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.offsetIds.length !== other.offsetIds.length) return false;
    for (let i = 0; i < this.offsetIds.length; i++) {
      const a = this.offsetIds[i];
      const b = other.offsetIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.offsetIds2delete.length !== other.offsetIds2delete.length) return false;
    for (let i = 0; i < this.offsetIds2delete.length; i++) {
      const a = this.offsetIds2delete[i];
      const b = other.offsetIds2delete[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyOffsetType(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
